<template>
  <base-container>
    <float-ball />
    <float-ball-slot />
  </base-container>
</template>

<script>
  import { createPage } from '@mpxjs/core'

  createPage({})
</script>

<style lang="stylus">

</style>

<script type="application/json">
  {
    "usingComponents": {
      "base-container": "../../components/base-container/index",
      "float-ball": "./float-ball",
      "float-ball-slot": "./float-ball-slot"
    }
  }
</script>
